<script>
import { Bar } from 'vue-chartjs/legacy';

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options);
  }
};
</script>

<style scoped>

</style>
